import { CircularProgress, IconButton, InputBase, Paper } from "@mui/material";
import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import ErrorComponent from "../../Components/ErrorComponent";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../Components/ScrollBar";
import RecentConsultation from "./RecentConsultation";
import { useAuth } from "../../Contexts/AuthContext";
import SearchIcon from "@mui/icons-material/Search";
import PreferredDoctor from "./PreferredDoctors";
import { Fragment, useState } from "react";

const BranchSelector = () => {
  const {
    setSelectedSpecialization,
    setSelectedDoctorBySearch,
    setSearchBranchResults,
    searchBranchResults,
    recentConsultations,
    setToSearchByDoctor,
    setSelectedClinic,
    setPreviewScreen,
    preferredDoctors,
    setSearchBranch,
    setSelectedTime,
    setSelectedDate,
    retrieveClinics,
    selectedClinic,
    searchBranch,
    pccLoadState,
    clinicData,
  } = useConsultDoctorContext();

  const { currentPos, isLocationDenied } = useAuth();

  const [collapsedList, setCollapsedList] = useState([
    "prefDocs",
    "recentConsult",
  ]);

  const geolib = require("geolib");

  const handleChange = (clinic) => {
    setSelectedClinic(clinic);
    setToSearchByDoctor(false);
    setSelectedDoctorBySearch(null);
    setSelectedDate();
    setSelectedTime();
    setSelectedSpecialization(null);
  };

  const handleSearch = (e) => {
    setSearchBranch(e.target.value);
    const filteredData = clinicData.filter(
      (data) =>
        data.providerName.toLowerCase().includes(searchBranch.toLowerCase()) ||
        data.address.toLowerCase().includes(searchBranch.toLowerCase())
    );
    setSearchBranchResults(filteredData);
  };

  const handleCollapse = (str) => {
    let list = [...collapsedList];
    let index = list.indexOf(str);
    if (index >= 0) {
      list.splice(index, 1);
      setCollapsedList(list);
    } else {
      list.push(str);
      setCollapsedList(list);
    }
  };

  const renderCollapseBodyClass = (str) => {
    if (collapsedList.includes(str)) {
      return "h-full";
    }
    return "h-0 overflow-hidden";
  };

  const handleViewAll = (str) => {
    setPreviewScreen(str);
  };

  const getCollapseIcon = (str) => {
    if (collapsedList.includes(str)) {
      return <KeyboardArrowDown sx={{ fontSize: 20 }} />;
    }
    return <KeyboardArrowUp sx={{ fontSize: 20 }} />;
  };

  const getViewAllClass = (arr) => {
    if (arr.length < 6) {
      return "hidden";
    }
    return "";
  };

  let branchesArray = clinicData;
  if (searchBranch) {
    branchesArray = searchBranchResults;
  }

  let pccContent = null;

  if (isLocationDenied && !currentPos) {
    pccContent = branchesArray?.map((data, index) => (
      <label
        id="labl"
        htmlFor={`branch-${index}`}
        className="flex flex-row w-full mt-1 cursor-pointer"
        key={data}
      >
        <input
          name="branch"
          id={`branch-${index}`}
          type="radio"
          onChange={() => handleChange(data)}
          checked={selectedClinic?.providerName === data.providerName}
        />
        <div className="flex flex-row text-sm p-3 border rounded-lg">
          <div className="ml-1 w-4/6 flex-grow">
            <p className="text-black">{data.providerName}</p>
          </div>
        </div>
      </label>
    ));
  } else {
    pccContent = branchesArray
      .map((data) => ({
        ...data,
        distance:
          geolib.getDistance(
            {
              latitude: currentPos?.latitude,
              longitude: currentPos?.longitude,
            },
            {
              latitude: parseFloat(data.latitude),
              longitude: parseFloat(data.longitude),
            }
          ) / 1000,
        withinRadius: geolib.isPointWithinRadius(
          {
            latitude: currentPos?.latitude,
            longitude: currentPos?.longitude,
          },
          {
            latitude: parseFloat(data.latitude),
            longitude: parseFloat(data.longitude),
          },
          20000
        ),
      }))
      .sort((a, b) => {
        if (a.withinRadius && !b.withinRadius) {
          return -1;
        } else if (!a.withinRadius && b.withinRadius) {
          return 1;
        } else {
          // If both are within radius or both are outside, sort by distance
          return a.distance - b.distance;
        }
      })
      .map((data, index) => (
        <label
          id="labl"
          htmlFor={`branch-${index}`}
          className="flex flex-row w-full mt-1 cursor-pointer"
          key={data}
        >
          <input
            name="branch"
            id={`branch-${index}`}
            type="radio"
            onChange={() => handleChange(data)}
            checked={selectedClinic?.providerName === data.providerName}
          />
          <div className="flex flex-row text-sm p-3 border rounded-lg">
            <div className="ml-1 w-4/6 flex-grow">
              <p className="text-black">{data.providerName}</p>
            </div>
            {data.distance ? (
              <div className="flex items-center text-xs text-center font-semibold text-gray-600">
                <div className="flex flex-col items-center">
                  <p>{data.distance.toFixed(2)} km</p>
                </div>
              </div>
            ) : null}
          </div>
        </label>
      ));
  }

  let prefDocsContent = null;
  if (preferredDoctors.length > 0 && !searchBranch) {
    prefDocsContent = (
      <div id="doctors-collapse" className="mb-3">
        <div className="flex items-center justify-between">
          <button
            className="flex-1 text-left py-2 text-[14px] font-bold"
            onClick={() => handleCollapse("prefDocs")}
          >
            <span className="mr-1">{getCollapseIcon("prefDocs")}</span>
            {/* */} Preferred Doctor
          </button>
          <button
            className={`text-[14px] font-bold text-[#0947ab] hover:underline
              ${getViewAllClass(preferredDoctors)}`}
            onClick={() => handleViewAll("prefDocs")}
          >
            View All
          </button>
        </div>
        <div className={renderCollapseBodyClass("prefDocs")}>
          <PreferredDoctor doctors={preferredDoctors.slice(0, 5)} />
        </div>
      </div>
    );
  }

  let recentConsultContent = null;
  if (recentConsultations.length > 0 && !searchBranch) {
    recentConsultContent = (
      <div id="recents-collapse" className="mb-3">
        <div className="flex items-center justify-between">
          <button
            className="flex-1 text-left py-2 text-[14px] font-bold"
            onClick={() => handleCollapse("recentConsult")}
          >
            <span className="mr-1">{getCollapseIcon("recentConsult")}</span>
            {/* */} Recent Consultation
          </button>
          <button
            className={`text-[14px] font-bold text-[#0947ab] hover:underline
              ${getViewAllClass(recentConsultations)}`}
            onClick={() => handleViewAll("recentConsult")}
          >
            View All
          </button>
        </div>
        <div className={renderCollapseBodyClass("recentConsult")}>
          <RecentConsultation consultations={recentConsultations.slice(0, 5)} />
        </div>
      </div>
    );
  }

  let content = null;
  if (pccLoadState === "load") {
    content = (
      <div className="w-full flex justify-center items-center mt-4">
        <CircularProgress />
      </div>
    );
  } else if (["ISE", "retry", "timeout"].includes(pccLoadState)) {
    content = (
      <ErrorComponent
        onRetry={() => retrieveClinics("retry")}
        isLoading={pccLoadState === "retry"}
      />
    );
  } else {
    content = (
      <Fragment>
        <Paper
          component="form"
          sx={{
            width: "100%",
            mt: 2,
            mb: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <IconButton disabled aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search clinic or city"
            value={searchBranch}
            onChange={(e) => handleSearch(e)}
            inputProps={{ "aria-label": "search google maps" }}
          />
        </Paper>
        <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
          <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-263px)] sm:h-full sm:max-h-[400px] rounded">
            {recentConsultContent}
            {prefDocsContent}
            {pccContent}
          </ScrollArea.Viewport>
          <ScrollBar />
        </ScrollArea.Root>
      </Fragment>
    );
  }

  return content;
};

export default BranchSelector;
